module.exports = __webpack_public_path__ + "img/26400.91ccc4cb.jpg";